export const loadingStatusAccordingToReducer = (loadingStatusName = '') => (state = false, action) => {
  const { name } = action;
  if (name !== loadingStatusName) return state;

  const suffix = action.type.split('_').pop();

  switch (suffix) {
    case 'SUCCESS':
    case 'FAILURE':
      return false;
    case 'REQUEST':
      return true;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/utils/reducers/loading-status/loading-status.js